import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLangChecker } from '@common/utils/i18n';
const useModelMeasures = () => {
    const { t } = useTranslation();
    const cmToInches = (measure) => (parseInt(measure) * 0.3937).toFixed(2);
    const measureConverter = (measure) => {
        if (!measure) {
            return null;
        }
        const isUSorCA = ['US', 'CA'].includes(window.country);
        const value = isUSorCA ? cmToInches(measure) : measure;
        return `${value}${isUSorCA ? t('sizeguide.uom.inches') : t('sizeguide.uom.cm')}`;
    };
    const fitString = (measures) => {
        // const fitLabel = `<b>${t('sizeguide.fit')} </b>`;
        const fit = measures.sizeAndFit ? `${measures.sizeAndFit}. ` : '';
        const model = measures.modelHeight && measures.modelSize ? t('sizeguide.model', { height: measureConverter(measures.modelHeight), size: measures.modelSize }) : '';
        return (React.createElement(React.Fragment, null,
            React.createElement("b", { ref: useLangChecker },
                t('sizeguide.fit'),
                " "),
            fit + model));
        // return fitLabel + fit + model;
    };
    // t('sizeguide.fit', { height: modelHeight(measures.modelHeight), size: measures.modelSize, fit: measures.sizeAndFit || '' });
    return { cmToInches, measureConverter, fitString };
};
export default useModelMeasures;
